export default __webpack_public_path__ + "static/media/gallery-img-3.92a41905.jpg";